import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { getToken } from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        count: 1,
        language: 'zh',
        menuList: [],//菜单列表
        oneIndex: null,//一级菜单选中id
        twoIndex: null,//二级菜单选中id
        config: null,//网站配置
        jumpPath: 0,//1关于我们 2产品中心 3产品详情
        topList: [],//分类
        add: 0,
        name:'',//网站名称
        describe:'',//网站描述
        title:'',//网站标题
        keyWords:'',//网站关键字
    },
    mutations: {
        getMenuList(state, value) {
            state.menuList = value || []
        },
        getConfig(state, value) {
            state.config = value || null
        },
        changeLanguage(state, value) {
            state.language = value || 'zh'
        },
        changeOneIndex(state, value) {
            state.oneIndex = value || null
        },
        changeTwoIndex(state, value) {
            state.twoIndex = value || null
        },
        changeJump(state, value) {
            state.jumpPath = value || null
        },
        changetopList(state, value) {
            state.topList = value || null
        },
        addList(state) {
            state.add++
        },
        getTitle(state){
        //     name:'',//网站名称
        // describe:'',//网站描述
        // title:'',//网站标题
        // keyWords:'',//网站关键字
            if(state.language == 'zh' && state.config && state.config.name){
                state.name = state.config.name;
            }
            if(state.language == 'zh' && state.config && state.config.describe){
                state.describe = state.config.description;
            }
            if(state.language == 'zh' && state.config && state.config.keywords){
                state.keyWords = state.config.keywords;
            }

            if(state.language != 'zh' && state.config && state.config.enName){
                state.name = state.config.enName;
            }
            if(state.language != 'zh' && state.config && state.config.enDescription){
                state.describe = state.config.enDescription;
            }
            if(state.language != 'zh' && state.config && state.config.enKeywords){
                state.keyWords = state.config.enKeywords;
            }
        }
    },
    actions: {
        browseAdd({ commit }, data) {
            commit('addList')
            axios({
                method: 'post',
                // url: 'http://hongyutech.sewworld.com/api/visits/browse',
                url: 'http://japanjukiadmin.jukicc.com/api/visits/browse',
                headers: {
                    Authorization: 'Bearer ' + getToken()
                },
                data
            })
        }
    },
    getters: {

    },
    modules: {

    }
})
